/**
 *
 * BillingCountryCard
 *
 */

import chevronForward from "@dhl-official/icons/chevron-forward.svg";
import Icon from "root/libs/ui-components/src/lib/Icons/Icon";
import React from "react";
import PropTypes from "prop-types";
import { IntlPropType, trackContentInteraction } from "root/libs/core-libs/src";
import { SEGMENT_TYPES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import { Sizes, Variants } from "@dhl-official/stencil-library";
import {
  UTF_EVENT_CONTENT_NAMES,
  UTF_EVENT_TYPES,
  UTF_EVENT_INTERACTIONS,
  UTF_EVENT_CONTENT_POSITION,
} from "root/libs/constants/src";
import ModalChangeBillingCountry from "one-time-shipment/src/components/Modals/ModalChangeBillingCountry";
import {
  DisabledCountryCard,
  BillingCountryNote,
  CountryLabel,
  CountryFlag,
  CountryWrapper,
  ChangeCountryButton,
} from "./styled";

export default class BillingCountryCard extends React.PureComponent {
  static propTypes = {
    abTestRunning: PropTypes.bool.isRequired,
    dataTestid: PropTypes.string,
    countryId: PropTypes.string,
    dataTracking: PropTypes.string,
    trackEvent: PropTypes.func,
    intl: IntlPropType.isRequired,
    toggleOriginAndDestination: PropTypes.func.isRequired,
    isBusiness: PropTypes.bool.isRequired,
    changeCountryURI: PropTypes.string.isRequired,
    changeCountryURIBusiness: PropTypes.string.isRequired,
    byTargetChangeCountryURIs: PropTypes.object,
    byTargetChangeCountryURIsBusiness: PropTypes.object,
    enableImportExport: PropTypes.bool,
  };

  static defaultProps = {
    dataTracking: "",
    dataTestid: "",
    countryId: "",
    trackEvent: () => {},
  };

  constructor(props) {
    super(props);
    this.state = { openChangeBillingCountryModal: false };
  }

  triggerClickTrackingEvent = () => {
    const { isBusiness } = this.props;

    trackContentInteraction({
      name: UTF_EVENT_CONTENT_NAMES.CHANGE_BILLING_COUNTRY,
      type: UTF_EVENT_TYPES.BUTTON,
      interaction: UTF_EVENT_INTERACTIONS.CLICK,
      position: UTF_EVENT_CONTENT_POSITION.TRADE_LANE,
      context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
    });
  };

  onClickHandler = () => {
    const { trackEvent } = this.props;

    trackEvent({ wrongCountry: true });
    this.triggerClickTrackingEvent();
    this.setState({ openChangeBillingCountryModal: true });
  };

  render() {
    const {
      abTestRunning,
      dataTestid,
      countryId,
      dataTracking,
      intl,
      toggleOriginAndDestination,
      isBusiness,
      changeCountryURI,
      changeCountryURIBusiness,
      byTargetChangeCountryURIs,
      byTargetChangeCountryURIsBusiness,
      enableImportExport,
    } = this.props;

    const { openChangeBillingCountryModal } = this.state;

    const getCopy = (id) => intl.formatMessage({ id });

    const hasPostcodesEnabled = !isBusiness;

    const messages = {
      billingCountry: getCopy("ChangeCountryTextAndLink.billingCountry"),
      countryLabel: getCopy(`CountryAutocompleteField.${countryId}`) || "",
      wrongCountryCopyOrigin: getCopy(
        "ChangeCountryTextAndLink.wrongCountryCopyOrigin"
      ),
      wrongCountryLinkUrl: getCopy(
        "ChangeCountryTextAndLink.wrongCountryLinkUrl"
      ),
      wrongCountryLinkText: getCopy(
        `ChangeCountryTextAndLink.${
          hasPostcodesEnabled ? "changeCountry" : "wrongCountryLinkText"
        }`
      ),
    };

    return (
      <DisabledCountryCard dataTestid={dataTestid}>
        <CountryWrapper>
          <CountryFlag country={countryId} />
          <CountryLabel
            ariaLabelledby="billing-country"
            tabIndex="0"
            dataTestid={dataTestid}
            dataCountryId={countryId}
          >
            {messages.countryLabel}
          </CountryLabel>
          <ChangeCountryButton
            clickEvent={this.onClickHandler}
            dataAriaLabel={`${messages.wrongCountryLinkText}`}
            dataTestid={`${dataTestid}-change-location-cta`}
            dataTracking={dataTracking}
            id={`${dataTestid}-cta`}
            name="button"
            hasPostcodesEnabled={hasPostcodesEnabled}
            size={Sizes.XS}
            type="button"
            variant={Variants.text}
            renderAsProps={{
              "aria-haspopup": "dialog",
              tabindex: 0,
            }}
          >
            {messages.wrongCountryLinkText}
            {hasPostcodesEnabled ? (
              <Icon
                icon={chevronForward}
                size="intermediate"
                useAs="decorative"
              />
            ) : undefined}
          </ChangeCountryButton>
        </CountryWrapper>
        <BillingCountryNote id="billing-country">
          <span className="visually-hidden">{messages.countryLabel} - </span>
          {messages.billingCountry}
        </BillingCountryNote>
        <ModalChangeBillingCountry
          abTestRunning={abTestRunning}
          intl={intl}
          isOpen={openChangeBillingCountryModal}
          onClose={() =>
            this.setState({
              openChangeBillingCountryModal: false,
            })
          }
          isBusiness={isBusiness}
          changeCountryURI={changeCountryURI}
          changeCountryURIBusiness={changeCountryURIBusiness}
          byTargetChangeCountryURIs={byTargetChangeCountryURIs}
          byTargetChangeCountryURIsBusiness={byTargetChangeCountryURIsBusiness}
          toggleOriginAndDestination={toggleOriginAndDestination}
          enableImportExport={enableImportExport}
        />
      </DisabledCountryCard>
    );
  }
}
